__webpack_require__.p = "/gimel-calculetor/";